<template>
  <div>
    <div class="modal-header" style="will-change: transform">
      <div class="row">
        <div class="col-12">
          <h3>
            <span id="incompleteHeading" v-if="rows.length > 1"
              >There are {{ rows.length }} bookings that need to be completed</span
            >
            <span id="incompleteHeading" v-if="rows.length === 1">There is 1 booking that needs to be completed</span>
          </h3>
        </div>
      </div>
    </div>

    <form name="incompleteBookingForm" autocomplete="off" novalidate>
      <div class="row">
        <div class="offset-md-1 col-10 m-t">
          <div class="alert alert-danger">
            <p>Enter the actual hours for the bookings below and press the Save button.</p>
            <p>Saving will complete the booking and adjust the time spent.</p>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="offset-md-1 col-3">
          <h4>Job</h4>
        </div>
        <div class="col-3">
          <h4>Date</h4>
        </div>
        <div class="col-2">
          <h4>Estimated</h4>
        </div>
        <div class="col-2">
          <h4>
            Actual&nbsp;
            <i class="fa fa-question-circle" title="Type the number of hours in each box, then press Save"></i>
          </h4>
        </div>
      </div>

      <div class="row">
        <div class="offset-md-1 col-10">
          <hr />
        </div>
      </div>

      <div class="row m-b" v-for="(booking, index) in rows" :key="booking._id || index">
        <div class="offset-md-1 col-3 sandbox-p-t-xxl">
          <div class="row">
            <div class="offset-md-1 col-10 sandbox-p-l-n">
              <strong
                >{{ booking.title }} &nbsp;<a
                  :id="'booking-notes-toggle-' + index"
                  v-if="booking.notes"
                  v-on:click="toggleNotes(booking)"
                >
                  <i class="fa fa-chevron-down"></i> </a
              ></strong>
            </div>
          </div>
          <div class="row">
            <div class="offset-md-1 col-10 sandbox-p-l-n">
              <small>{{ booking.resources }}</small>
            </div>
          </div>
        </div>

        <div class="col-3 sandbox-p-t-xxl">
          <span>{{ formatStartsAt(booking.startsAt) }}</span>
        </div>
        <div class="col-2 sandbox-p-t-xxl">
          <span>{{ booking.duration }}</span>
        </div>

        <div class="col-2">
          <div class="row">
            <div class="col-9">
              <!--
                was `ng-class='{"has-error": !newHoursAreValid(...)}'` + `ng-model='booking.actual'`
                with `required`. newHoursAreValid stays on the controller (it renders the range
                error, and the controller already owns the data shaping); the required-field gate
                that was `incompleteBookingForm.$valid` is `formIsInvalid` here.
              -->
              <div class="form-group" :class="{ 'has-error': !newHoursAreValid(booking.startsAt, booking.actual) }">
                <input
                  class="form-control"
                  :id="'booking-actual-' + index"
                  v-model="booking.actual"
                  type="text"
                  name="bookingActual"
                  required
                />
              </div>
            </div>
          </div>

          <div class="row m-b" v-if="booking.actual && !newHoursAreValid(booking.startsAt, booking.actual)">
            <div class="col-12">
              <small class="text-danger" id="invalidHoursError">Hours must be between 0 and the end of the day</small>
            </div>
          </div>
        </div>

        <!-- was `uib-collapse='booking.showNotes'`; b-collapse is the BootstrapVue equivalent,
             with the same show/hide transition. -->
        <div v-show="booking.showNotes" class="offset-md-1 col-10 m-t">
          <div class="alert alert-info">
            <p :id="'booking-notes-' + index">{{ booking.notes }}</p>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <div class="row m-b">
          <div class="col-12">
            <button class="btn btn-default" id="cancelIncompleteBookingsButton" v-on:click="cancel" title="Cancel">
              Cancel
            </button>
            <button
              class="btn btn-primary"
              id="saveIncompleteBookingsButton"
              v-on:click="save"
              :disabled="formIsInvalid"
              title="Save"
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'IncompleteBookingsComponent',
  props: {
    bookings: {
      type: Array,
      default: () => [],
    },
    // The controller's range check - it stays there because the controller already shapes the
    // booking data (duration/resources) that the view renders, and it is unit-tested directly.
    // `(bookingStart, hours) => boolean`
    newHoursAreValid: {
      type: Function,
      required: true,
    },
  },
  data() {
    // Editable copies: the component owns `actual` and the notes toggle, so the parent's array
    // is never mutated in place (the ngVue `reference`-depth watch trap).
    return {
      rows: (this.bookings || []).map(booking => ({ ...booking, showNotes: true })),
    }
  },
  computed: {
    // Was `!incompleteBookingForm.$valid`. The only `required` inputs are the `actual` fields.
    formIsInvalid() {
      return this.rows.some(row => row.actual === null || row.actual === undefined || row.actual === '')
    },
  },
  methods: {
    // Angular's `date:'EEE, d MMM'` (browser-local), e.g. "Mon, 3 Feb".
    formatStartsAt(value) {
      return moment(value).format('ddd, D MMM')
    },
    toggleNotes(booking) {
      booking.showNotes = !booking.showNotes
    },
    save() {
      this.$emit('save', this.rows)
    },
    cancel() {
      this.$emit('cancel')
    },
  },
}
</script>
